// extracted by mini-css-extract-plugin
export var logo = "_m4-2";
export var logoWrapper = "_m4-1";
export var strip = "_m4-0";